import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string;
  subValue?: string;
  icon: LucideIcon;
  iconBgColor?: string;
  iconColor?: string;
  badge?: {
    text: string;
    variant?: "default" | "secondary" | "destructive" | "outline";
  };
  trend?: {
    value: string;
    icon: LucideIcon;
    color: string;
  };
}

export function StatCard({
  title,
  value,
  subValue,
  icon: Icon,
  iconBgColor = "bg-primary/10",
  iconColor = "text-primary",
  badge,
  trend,
}: StatCardProps) {
  return (
    <Card className="h-full">
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          <div className={`shrink-0 p-3 rounded-full ${iconBgColor}`}>
            <Icon className={`h-6 w-6 ${iconColor}`} />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-muted-foreground truncate">{title}</p>
            <div className="mt-1 flex flex-wrap items-center gap-2">
              <h3 className="text-2xl font-bold truncate">{value}</h3>
              {trend && (
                <span className={`inline-flex items-center text-sm ${trend.color} shrink-0`}>
                  <trend.icon className="h-4 w-4 mr-1" />
                  {trend.value}
                </span>
              )}
              {badge && (
                <Badge variant={badge.variant} className="shrink-0">
                  {badge.text}
                </Badge>
              )}
            </div>
            {subValue && (
              <p className="text-sm text-muted-foreground mt-1 truncate">{subValue}</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}